import { render, staticRenderFns } from "./ODAVF000.vue?vue&type=template&id=2e48f0df"
import script from "./ODAVF000.vue?vue&type=script&lang=js"
export * from "./ODAVF000.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports